import {DDR} from './ddr.class';

export class DDRMen1930Strategy extends DDR {
  constructor() {
    super([900, 5, 15, 120, 90, 1.2, 1.3, 16, 1.3, 400, 2.5, 5, 30, 550, 1000, 35, 900, 4, 150, 8, 400, 2.3, 700, 55, 11]);
  }
}
